var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBusinessOwnerConsultation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2999A7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(0 -34.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    transform: "translate(1.698 70.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st0",
    d: "M183.5,72.9c-2.2-0.1-4.1,1.5-4.3,3.7c0,0.2,0,0.3,0,0.5v55.4c0.1,2.2-1.5,4.1-3.7,4.3 c-0.2,0-0.3,0-0.5,0H21.6c-2.2,0.1-4.1-1.5-4.3-3.7c0-0.2,0-0.3,0-0.5V77.1c0.1-2.2-1.5-4.1-3.7-4.3c-0.2,0-0.3,0-0.5,0 c-2.2-0.1-4.1,1.5-4.3,3.7c0,0.2,0,0.3,0,0.5v55.4c-0.1,6.9,5.4,12.7,12.3,12.8c0.2,0,0.3,0,0.5,0H175 c6.9,0.1,12.7-5.4,12.8-12.3c0-0.2,0-0.3,0-0.5V77.1c0.1-2.2-1.5-4.1-3.8-4.3C183.9,72.9,183.7,72.9,183.5,72.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    transform: "translate(0 46.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st0",
    d: "M181,37H19c-6.9-0.1-12.7,5.4-12.8,12.3c0,0.2,0,0.3,0,0.5V77c0,5.9,4.1,11,9.8,12.4l66.9,14.9 V118c-0.1,2.2,1.5,4.1,3.7,4.3c0.2,0,0.3,0,0.5,0h25.6c2.2,0.1,4.1-1.5,4.3-3.7c0-0.2,0-0.3,0-0.5v-13.6L184,89.4 c5.7-1.4,9.8-6.5,9.8-12.4V49.8c0.1-6.9-5.4-12.7-12.3-12.8C181.3,37,181.1,37,181,37z M108.5,113.7h-17v-17h17V113.7z M185.2,77 c0.1,2.1-1.4,3.9-3.4,4.3l-64.8,14.5v-3.4c0.1-2.2-1.5-4.1-3.7-4.3c-0.2,0-0.3,0-0.5,0H87.2c-2.2-0.1-4.1,1.5-4.3,3.7 c0,0.2,0,0.3,0,0.5v3.4L18.2,81.3c-2-0.4-3.5-2.2-3.4-4.3V49.8c-0.1-2.2,1.5-4.1,3.7-4.3c0.2,0,0.3,0,0.5,0H181 c2.2-0.1,4.1,1.5,4.3,3.7c0,0.2,0,0.3,0,0.5L185.2,77z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    transform: "translate(23.764 34.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st0",
    d: "M97.5,19H54.9c-6.9-0.1-12.7,5.4-12.8,12.3c0,0.2,0,0.3,0,0.5v4.3c0.1,2.4,2.1,4.2,4.5,4 c2.2-0.1,3.9-1.9,4-4v-4.3c-0.1-2.2,1.5-4.1,3.7-4.3c0.2,0,0.3,0,0.5,0h42.6c2.2-0.1,4.1,1.5,4.3,3.7c0,0.2,0,0.3,0,0.5v4.3 c0.1,2.4,2.1,4.2,4.5,4c2.2-0.1,3.9-1.9,4-4v-4.3C110.5,24.9,105,19.2,98,19C97.9,19,97.7,19,97.5,19z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessOwnerConsultation);
export default __webpack_public_path__ + "static/media/Icon_Business_Owner_consultation.a4809d600a94a61d6af573d2a30663b5.svg";
export { ForwardRef as ReactComponent };